import React, {useState, useEffect, useRef} from 'react';
import {Row, Col, Input, Button, Icon} from 'antd';
import MapImage from "../../../assets/images/L16.jpg";
import NavImage from "../../../assets/images/nav.jpg";
import LeftImage from "../../../assets/images/L18.jpg";
import HistogramImage from "../../../assets/images/L17.jpg";
import DroneImage from "../../../assets/images/L14.png";
import NightVisionOverlayImage from "../../../assets/images/night_vision(red).png";
import EmergencyReturnOverlayImage from "../../../assets/images/Emergency_Return(red).png";
import GPSLeftImage from "../../../assets/images/gps_left.jpg";
import GPSTopLeftImage from "../../../assets/images/gps_top_left.jpg";
import GPSTopRightImage from "../../../assets/images/gps_top_right.jpg";
import GPSBottomImage from "../../../assets/images/gps_bottom.jpg";
import ResetSvg from "../../../assets/images/drone-icon-reset.svg";
import MicSvg from "../../../assets/images/drone-icon-mic.svg";
import RegenSvg from "../../../assets/images/drone-icon-regen.svg";
import SendSvg from "../../../assets/images/plane.svg";
//import LandingTest from './AGS_View';
import {sleep} from "../../utils/utilfunc"
import axios from "axios";
import Swal from 'sweetalert2';
import MyAudioRecorder from "../../utils/MyAudioRecorder";
import {USER_SERVER} from '../../../config'
import {removeCookie} from "../../../cookie/cookie";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { v4 as uuidv4 } from 'uuid';

function LandingPage(props) {
    //let user = useSelector((state) => state.user);
    //const UserInfo = user.userData;     // UserInfo={token, user_id}
    //const isAuth = UserInfo?.isAuth;

    const vrecorder = useRef(null);
    const audioRef = useRef(new Audio());
    const [UserInfo, setUserInfo] = useState({});
    const [HistoryList, setHistoryList] = useState([]);
    const [Question, setQuestion] = useState('');
    const [Mp3Url, setMp3Url] = useState(null);
    const [WhilePlay, setWhilePlay] = useState(false);

    const [RecStatus, setRecStatus] = useState('ready');
    const [WaitAnswer, setWaitAnswer] = useState(false);
    const [ShowAnswer, setShowAnswer] = useState(false);
    const [MicFilter, setMicFilter] = useState('invert(100%)');
    const [WaitMicReady, setWaitMicReady] = useState(false);
    const [TTS, setTTS] = useState(true);              // enable TTS (mic 사용시는 이 설정에 상관없이 TTS작동됨)

    //const nav_height = Math.floor(150/1752*window.innerHeight);
    const [nav_height, setNavHeight] = useState(Math.floor(150/1752*window.innerHeight));
    const [body_height, setBodyHeight] = useState(window.innerHeight - nav_height);
    const [histo_height, setHistoHeight] = useState(Math.floor(330/1752*window.innerHeight));
    const [drone_height, setDroneHeight] = useState(Math.floor(940/1752*window.innerHeight));
    //const [gps_height, setGpsHeight] = useState(Math.floor(540/1752*window.innerHeight));
    const [gps_height, setGpsHeight] = useState(window.innerHeight-drone_height-nav_height-20);

    // 크기 관련 정보 얻기
    window.addEventListener('resize', () => {
        //console.log("Updated viewport height:", window.innerHeight);
        setNavHeight(Math.floor(150/1752*window.innerHeight));
        setBodyHeight(window.innerHeight - nav_height);
        setHistoHeight(Math.floor(330/1752*window.innerHeight));
        const drone_height = Math.floor(940/1752*window.innerHeight);
        setDroneHeight(drone_height);
        setGpsHeight(window.innerHeight-drone_height-nav_height-20);
    });


    ///////////////////////////// SCENARIO /////////////////////////////////////
    const [Scenario, setScenario] = useState(null);
    // useEffect(() => {
    //     fetch("/scenario.json")
    //       .then((res) => res.json())
    //       .then((data) => setScenario(data));
    //   }, []);

    useEffect(() => {
        get_scenario();
    }, []);

    async function get_scenario() {
        const res = await axios.post(`${USER_SERVER}/get_scenario`, {});
        console.log('--------------get_scenario-------------', res);
        setScenario(res.data);
    }
    

    ///////////////////////////// LOGIN /////////////////////////////////////
    useEffect(() => {
        if (UserInfo?.token)
            return;

        const storedUserId = localStorage.getItem('user_id');
        let newUserId; // Declare newUserId here
        if (!storedUserId) {
            newUserId = uuidv4(); // Generate a new unique ID
            localStorage.setItem('user_id', newUserId);
        }
        
        // Use the storedUserId for automatic login
        const dataToCommit = {user_id: (storedUserId || newUserId), password: '123456'};
        login_user_id(dataToCommit);
    }, []);


    async function login_user_id(dataToCommit) {
        const res = await axios.post(`${USER_SERVER}/web/login_user_id`, dataToCommit).then(response => response.data);

        if (res.loginSuccess) {
            const UserInfo = {user_id: res.userId, token: res.token};
            setUserInfo(UserInfo);
            console.log('Logged in successfully. UserInfo=', UserInfo);
        } else {
            console.log('Logged in FAILED!!!');
        }
    }

    ///////////////////////////// AGS /////////////////////////////////////
    const initialList = { 
        nightVision:           'false',
        emergencyReturn:       'false',

        debug_info:             'blabla...'
    };
    const [AGSState, setAGSState] = useState(initialList);

    function change_ags_state(key, val){
        setAGSState(prev => ({ ...prev, [key]: val }));
    }

    async function my_send_ags() {
        console.log('send ags----------------------', UserInfo, AGSState);

        const res = await axios.post(`${USER_SERVER}/ags/set_params`, {user_id:UserInfo.user_id, change_dict:AGSState});
        console.log('ags_set_params--------->', res);
        if (res.data?.success) {
            ;
        } else {
            console.log('ERROR', res);
        }
    }

    // ags 값이 바뀌면 backend로 보냄
    useEffect(() => {
        console.log('ags value =', AGSState);
        if (UserInfo && UserInfo.user_id) {
            console.log('ags value changed!!! so send to backend22222');
            my_send_ags();
        }
    }, [UserInfo, AGSState]);
    

    ///////////////////////////// CHAT /////////////////////////////////////

    useEffect(() => {
        get_chat_history();
    }, [UserInfo]);

    useEffect(() => {
        const handleEnded = () => {
            setWhilePlay(false);
        };

        // url이 null이 아닐 때만 재생
        if (Mp3Url) {
            setWhilePlay(true);
            audioRef.current.src = Mp3Url;
            audioRef.current.play().catch(error => console.log("재생 중 오류 발생:", error));
            audioRef.current.addEventListener('ended', handleEnded);
        }

        // Clean up the event listener when the component unmounts or Mp3Url changes
        return () => {
            if (audioRef.current) {
                audioRef.current.removeEventListener('ended', handleEnded);
            }
        };
    }, [Mp3Url]); // url 상태가 변경될 때마다 이 효과를 실행

    async function get_chat_history() {
        if (!UserInfo?.token) {
            console.log('get_chat_history FAILED!!!');
            return;
        }

        console.log('get_chat_history UserInfo=', UserInfo);
        const res = await axios.post(`${USER_SERVER}/get_chat_history`, {
            user_id: UserInfo.user_id,
            token: UserInfo.token
        });
        console.log('get_chat_history--------->', res);
        if (res.data?.success) {
            setHistoryList(res.data.data);
        } else {
            show_error(res);
        }
    }

    // error 나면 에러 정보를 디스플레이
    function show_error(res) {
        const tdata = res.data.data;
        if (typeof tdata === 'object' && 'title' in tdata) {
            Swal.fire({
                title: res.data.data.title,
                text: res.data.data.description,
                icon: 'info',
                confirmButtonText: '확인'
            });
            if (tdata.type == 'tokenExpired') {
                removeCookie('w_auth');
                props.history.push("/login");
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: res.data.data,
                icon: 'error',
                confirmButtonText: '확인'
            });
        }
    }


    // async function send_question_with_image(question, img) {
    //     console.log("send_question_with_image", img);
    //     setWaitAnswer(true);
    //     const formData = new FormData();
    //     formData.append('image', img);
    //     formData.append('question', question.trim());
    //     formData.append('user_id', UserInfo.user_id);
    //     formData.append('token', UserInfo.token);
    //     formData.append('tts', false);
    //     formData.append('status', JSON.stringify({
    //         hw_state: ''
    //     }));

    //     const res = await axios.post(`${USER_SERVER}/get_answer`, formData, {headers: {"Content-Type": "multipart/form-data"}});
    //     //URL.revokeObjectURL(ImgUrl);
    //     //setImgUrl("")
    //     //setImg(null);
    //     setWaitAnswer(false);
    //     console.log('get_answer--------->', res);
    //     if (res.data?.success) {
    //         await process_answer(res.data.data);
    //     } else {
    //         show_error(res);
    //     }
    // }

    async function send_question(question) {
        setWaitAnswer(true);
        const currentDate = new Date();
        const dataToCommit = {
            token: UserInfo.token,
            user_id: UserInfo.user_id,
            question: question.trim(),
            tts: TTS,
            status: {hw_state: ''},
        }

        const res = await axios.post(`${USER_SERVER}/get_answer`, dataToCommit);
        setWaitAnswer(false);
        console.log('get_answer--------->', res);
        if (res.data?.success) {
            await process_answer(res.data.data);
        } else {
            show_error(res);
        }
    }

    function get_key_val(myobj) {
        let mykey=null, myval=null;
        const key_list = Object.keys(myobj);
        if (key_list.length>0) {
            mykey = key_list[0];
            myval = myobj[mykey];
        }
        return [mykey, myval]
    }

    async function process_answer(data) {
        console.log('process_answer------------------------>', data);
        const question = data.question;
        const answer = data.answer;
        const control_object = data.control;
        const user_msg = {speaker: 'h', message: question, image: data.image};
        const assistant_msg = {speaker: 'c', message: answer};
        const role = data?.role;
        setHistoryList(prev => [...prev, user_msg, assistant_msg]);
        setShowAnswer(true);

        // if (data?.function) {
        //     const tstr = JSON.stringify(data.function);
        //     const newstr = tstr.replace(/["\\"]/g, '');
        //     if (newstr !== '{}') {                 // empty 이면 추가 안함
        //         assistant_msg.gptfunc = newstr;
        //     }
        // }

        const [control_key, control_val] = get_key_val(control_object);

        if (control_key) {
            change_ags_state(control_key, control_val);
        }

        if (data?.tts_url) {
            setMp3Url(data.tts_url);
        }
    }

    let prevSpeaker = null; // 이전 speaker를 저장할 변수

    const render_histlist = HistoryList && HistoryList.map(function (hist, index) {
        const prompt = (prevSpeaker !== hist.speaker) ? (hist.speaker === 'h' ? 'User:  ' : 'AI:  ') : '';
        const hist_msg = hist.message;
        prevSpeaker = hist.speaker; // 현재 speaker를 이전 speaker로 업데이트

        return (
            <div key={index}>
                <Row>
                    <Col style={{fontSize: '24px', color: 'inherit'}}>
                        {/* {prompt}
                        <MarkdownRenderer text={hist_msg}/> */}
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {`${prompt}${hist_msg}`}
                        </ReactMarkdown>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {hist.speaker === 'c' && <br/>}
                    </Col>
                </Row>
                {/* {hist.speaker === "c" && index !== HistoryList.length - 1 && <hr/>} */}
            </div>
        );
    });


    async function sendDataToBackend(data) {
        try {
            setWaitAnswer(true);
            const formData = new FormData();
            // if (Img) {
            //     formData.append("image", Img);
            // }
            formData.append('audio', data);
            formData.append('user_id', UserInfo.user_id);
            formData.append('token', UserInfo.token);
            formData.append('status', JSON.stringify({
                //parking_remaining_sec: get_parking_remaining_sec()
                hw_state: ''
            }));

            const res = await axios.post(`${USER_SERVER}/get_answer_speech`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setWaitAnswer(false);
            console.log('get_answer_speech --------->', res);
            if (res.data?.success) {
                await process_answer(res.data.data);
            } else {
                show_error(res);
            }

            console.log('Data sent successfully', res);
        } catch (error) {
            console.error('Error sending data to backend', error);
        }
    }

    function MarkdownRenderer({text}) {
        return (
            <>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {text}
                </ReactMarkdown>
            </>
        );
    };

    function onClickStopPlaying() {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setWhilePlay(false);
        }
    };


    //////////////////////////////////////////////////////////////////////////////
    async function onClickSend() {
        if (!UserInfo?.token) {
            loginHandler();
            return;
        }
        await send_question(Question);
    }


    async function onClickRec() {
        if (WaitMicReady) {
            return;
        }

        if (RecStatus === 'ready') {
            await onClickRecStart();
        } else {
            await onClickRecStop();
        }
    }


    async function onClickRecStart() {
        console.log('onClickRecStart=', RecStatus);
        if (RecStatus !== 'ready') {
            return;
        }

        updateRecStatus('prepare_rec');
        try {
            vrecorder.current = new MyAudioRecorder();

            await vrecorder.current.openMic();
            await vrecorder.current.start_recording();
            updateRecStatus('rec');
        } catch (err) {
            console.log(err.message);	// device가 없어서 error가 난 것으로 추정
            updateRecStatus('ready');
        }
    }


    // stop recording
    async function onClickRecStop() {
        console.log('onClickRecStop=', RecStatus);
        if (RecStatus !== 'rec') {
            return;
        }
        updateRecStatus('prepare_stop');
        await vrecorder.current.stop_recording();

        for (let k = 0; k < 30; k++) {
            const vsign_url = vrecorder.current.get_blob_url();
            if (vsign_url === 'too_short') {
                updateRecStatus('ready');
                console.log('too short ---------------------------------', k);
                return;
            } else if (vsign_url) {
                console.log('check recorded data --------------------', k, vsign_url);
                const data = vrecorder.current.get_recorded_blob();
                await sendDataToBackend(data);
                updateRecStatus('ready');
                console.log('======', vsign_url, k)
                return;
            }
            await sleep(100);
        }
        alert('Error');
    }


    // async function onClickUploadImage() {
    //     console.log('onClickUploadImage');
    // }


    async function onClickReset() {
        console.log('onClickReset');
        setWaitAnswer(true);
        const res = await axios.post(`${USER_SERVER}/reset_history`, {
            token: UserInfo.token,
            user_id: UserInfo.user_id
        });
        console.log('reset_history--------->', res);
        if (res.data?.success) {
            await get_chat_history();
        } else {
            alert('Error:' + res.data.data);
        }
        setWaitAnswer(false);
        setShowAnswer(false);
    }

    async function onClickView() {
        console.log('onClickView');
        setShowAnswer(!ShowAnswer);
    }


    ////////////////////////////////////////////////////////////////////////
    function process_answer_sequence(data) {
        const answer = data.answer;
        console.log('process_answer_sequence', answer);
        setHistoryList(prev => {
            if (prev.length === 0) {
                const assistant_msg = {speaker: 'c', message: answer};
                return [assistant_msg];
            }
            console.log('process_answer_sequence 1', prev);
            console.log('process_answer_sequence 2', answer);
            const lastItem = prev[prev.length - 1];
            const updatedLastItem = {
                ...lastItem,
                message: lastItem.message + answer
            };
            return [...prev.slice(0, -1), updatedLastItem];
        });
    }

    async function put_answer(question) {
        console.log('add_answer', question);
        const dataToCommit = {
            token: UserInfo.token,
            user_id: UserInfo.user_id,
            question: question
        }

        const res = await axios.post(`${USER_SERVER}/put_answer`, dataToCommit);
        console.log('put_answer--------->', res);
        if (res.data?.success) {
            await process_answer_sequence(res.data.data);
        } else {
            show_error(res);
        }
    }


    function get_tts_only(question) {
        console.log('get_tts_only', question);
        setWaitAnswer(true);
        const dataToCommit = {
            question: question.trim(),
        }

        axios.post(`${USER_SERVER}/get_tts_only`, dataToCommit)
            .then(res => {
                setWaitAnswer(false);
                console.log('get_tts_only--------->', res);
                if (res.data?.success) {
                    //process_answer_sequence(res.data.data);
                    if (res.data.data?.tts_url) {
                        setMp3Url(res.data.data.tts_url);
                    }
            
                } else {
                    show_error(res);
                }
            })
            .catch(error => {
                setWaitAnswer(false);
                console.error('Error fetching TTS only:', error);
                show_error(error);
            });
    }

    // async function onClickDroneStatus() {
    //     console.log('onClickDroneStatus');
    //     if (!UserInfo?.token) {
    //         console.log('onClickDroneStatus token FAILED!!!');
    //         return;
    //     }
    //     setShowAnswer(true);
    //     get_tts_only('network is disconnected. I need to check the status of drone.\n');
    //     console.log('put_answer 1----------------');
    //     await sleep(2000);
    //     await put_answer('network is disconnected. I need to check the status of drone.\n\n');
    //     await sleep(800);
    //     await put_answer("You have been given the task of monitoring the enemy's movements stationed in the Shenzhen area. ");
    //     await sleep(800);
    //     await put_answer("You need to continuously transmit the results of your monitoring, but the network is currently down.\n\n");
    //     await sleep(800);
    //     await put_answer("First, you need to monitor the current status of the drone to make sure it is not broken, and monitor the enemy's movements.Virtually check the battery, current altitude, GPS jamming, etc., and present the figures and tell me that there are no abnormalities.\n\n");
    //     await sleep(800);
    //     await put_answer('Starting the return journey.\n\n');
    // }


    async function onClickDroneStatus() {
        console.log('onClickDroneStatus');
        if (!UserInfo?.token) {
            console.log('onClickDroneStatus token FAILED!!!');
            return;
        }
        setShowAnswer(true);
        const tts_str = Scenario.tts;
        const sequence = Scenario.sequence;

        get_tts_only(tts_str);
        for (const item of sequence) {
            await sleep(item.wait);
            
            await put_answer(item.answer);
        }
    }

    function onClickTTS() {
        setTTS(!TTS);
    }


    ///////////////////////////////////////////////////////////////////////////
    const updateRecStatus = (newStatus) => {
        console.log('updateRecStatus=', newStatus);
        setRecStatus(newStatus);        
        console.log('---------------');
        if (newStatus === 'ready') {
            setMicFilter('invert(100%)');
        } else {
            setMicFilter('invert(0%)');
        }

        if (newStatus === 'prepare_stop') {
            setWaitMicReady(true);
        } else {
            setWaitMicReady(false);
        }
    };


    // useEffect(() => {
    //     console.log('ImgUrl=', ImgUrl);
    // }, [ImgUrl]);

    function loginHandler(){
        window.location.href = "/login";
    }

    useEffect(() => {
        if (ShowAnswer) {
            const divEl = document.getElementById("hide-scroll");
            if (divEl) {
                divEl.scrollTo({ behavior: "smooth", top: divEl.scrollHeight });
            }
        }
    }, [HistoryList, ShowAnswer]);

    // const buttonStyle = {
    //     color: TTS ? 'green' : 'red', // TTS가 true이면 녹색, false이면 빨간색
    // };

    return (
        <div style={{backgroundColor: 'rgb(49,30,32)'}}>
            <Row style={{height: `${nav_height}px`, justifyContent: 'center'}}>
                <img
                    src={NavImage}
                    alt="Nav"
                    style={{
                        width: '100%',
                        //height: '50%',
                        //maxheight: `${nav_height*0.9}px`,
                        //display: 'block',
                        //objectFit: 'cover',
                        maxWidth: '100%'
                    }}
                />
            </Row>
            <Row style={{align: "top", justifyContent: "center"}}>
                {/* left bar*/}
                <Col span={2}>
                    <img
                        src={LeftImage}
                        alt="Map"
                        style={{
                            width: '100%',
                            height: `${body_height}px`,
                            display: 'block',
                            objectFit: 'cover'
                        }}
                    />
                </Col>
                {/* ---------------------------- center ------------------------------------- */}
                <Col span={11} style={{width: '100%', height: `${body_height}px`}}>
                    {ShowAnswer ? <Row 
                                    style={{
                                        height: `${body_height-histo_height}px`, 
                                        marginLeft: '10px',
                                        overflowY: "scroll"
                                    }}
                                    id={"hide-scroll"}
                                >
                                    <Col style={{margin: '10px', color: 'white'}}>
                                        {render_histlist}
                                    </Col>
                                </Row>:
                                <Row>
                                    <img
                                        src={MapImage}
                                        alt="Map"
                                        style={{
                                            width: '100%',
                                            height: `${body_height-histo_height}px`,
                                            display: 'block'
                                        }}
                                    />
                                </Row>}
                    <Row>
                        <img
                            src={HistogramImage}
                            alt="Map"
                            style={{
                                width: '100%',
                                height: `${histo_height}px`,
                                display: 'block'
                            }}
                        />
                    </Row>
                </Col>

                {/* ------------------------------ right ----------------------------------- */}
                <Col span={11} style={{height: `${body_height}px`}}>
                    {/* drone */}
                    <Row style={{position: 'relative'}}>
                        <img
                            src={DroneImage}
                            alt="Drone"
                            style={{
                                width: '100%',
                                height: `${drone_height}px`,
                                display: 'block',
                                objectFit: 'cover'
                            }}
                        />
                        {AGSState.nightVision === 'true' ? 
                            <img 
                                src={NightVisionOverlayImage} 
                                alt="NightVision" 
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    objectFit: 'cover'
                                }} 
                            /> 
                        : null}
                        {AGSState.emergencyReturn === 'true' ? 
                            <img 
                                src={EmergencyReturnOverlayImage} 
                                alt="EmergencyReturn" 
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    objectFit: 'cover'
                                }} 
                            /> 
                        : null}
                    </Row>
                    {/* ------------------------------ gps ----------------------------------- */}
                    <Row style={{marginTop: '10px', height: `${gps_height}px`}}>
                        <Col span={8}>
                            <img
                                src={GPSLeftImage}
                                alt="GPS"
                                style={{
                                    width: '100%',
                                    height: `${gps_height}px`,
                                    display: 'block'
                                }}
                            />
                        </Col>
                        <Col span={16}>
                            <Row>
                                <Col span={11}>                                
                                    {/* ----------------- drone status ------------------- */}
                                    <img
                                        src={GPSTopLeftImage}
                                        alt="GPSTopLeft"
                                        onClick={onClickDroneStatus}
                                        style={{
                                            width: '100%',
                                            height: `${gps_height*0.5}px`,
                                            display: 'block',
                                            cursor: 'pointer',
                                            transition: 'opacity 0.3s',
                                        }}
                                        onMouseDown={(e) => e.currentTarget.style.opacity = '0.6'}
                                        onMouseUp={(e) => e.currentTarget.style.opacity = '1'}
                                    />
                                </Col>
                                <Col span={13}>
                                    <Row>
                                        <img
                                            src={GPSTopRightImage}
                                            alt="GPSTopRight"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                display: 'block'
                                                }}
                                        />

                                    </Row>
                                    {/* ----------------- regen, mic, reset ------------------- */}
                                    <Row style={{marginTop: `${drone_height*0.05}px`}} justify="space-around">
                                        <Col span={6}>
                                            <img 
                                                src={RegenSvg} 
                                                onClick={onClickView} 
                                                style={{ fontSize: '96px', cursor: 'pointer', filter: 'invert(100%)'}} 
                                                alt="Regen" 
                                                onMouseDown={(e) => e.currentTarget.style.opacity = '0.6'}
                                                onMouseUp={(e) => e.currentTarget.style.opacity = '1'}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            {WaitMicReady ? <span style={{color: 'orange', fontSize: '2vw', textAlign: 'center', display: 'block', marginTop: '10px'}}>WAIT</span> :
                                                <img src={MicSvg} onClick={onClickRec} style={{ fontSize: '96px', cursor: 'pointer', filter: MicFilter}} alt="Mic" />
                                            }
                                        </Col>
                                        <Col span={6}>
                                            <img 
                                                src={ResetSvg} 
                                                onClick={onClickReset} 
                                                style={{ fontSize: '96px', cursor: 'pointer', filter: 'invert(100%)'}} 
                                                alt="Reset" 
                                                onMouseDown={(e) => e.currentTarget.style.opacity = '0.6'}
                                                onMouseUp={(e) => e.currentTarget.style.opacity = '1'}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop: '10px'}} justify="space-around">
                                        <Col span={6} style={{textAlign: 'center'}}>
                                            <span style={{fontSize: '1vw', color: 'lightcyan'}}>View</span>
                                        </Col>
                                        <Col span={6} style={{textAlign: 'center'}}>
                                            <span style={{fontSize: '1vw', color: 'lightcyan'}}>Mic</span>
                                        </Col>
                                        <Col span={6} style={{textAlign: 'center'}}>
                                            <span style={{fontSize: '1vw', color: 'lightcyan'}}>Reset</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <img
                                    src={GPSBottomImage}
                                    alt="GPS"
                                    style={{
                                        width: '100%',
                                        height: `${gps_height*0.43}px`,
                                        display: 'block'
                                    }}
                                />
                            </Row>
                        </Col>
                    </Row>

                    {/* chat */}
                    <Row align="middle" style={{marginTop: '10px'}}>
                        <Col span={1}>
                            <div onClick={onClickTTS} style={{cursor: 'pointer', color: TTS ? 'green' : 'darkred', fontSize: '10px', textAlign: 'center', display: 'block', marginTop: '10px'}}><strong>TTS</strong></div>
                        </Col>
                        <Col span={20}>
                            <Input
                                disabled={WaitAnswer}
                                value={Question}
                                onChange={(e) => {
                                    setQuestion(e.currentTarget.value);
                                }}
                                onPressEnter={onClickSend}
                                style={{
                                    width: '100%', 
                                    height: '60px',
                                    backgroundColor: 'black',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '32px',
                                }}
                            />
                        </Col>
                        <Col span={2}>
                            <img src={SendSvg} alt="Send" onClick={onClickSend} style={{height: '80px', cursor: 'pointer'}} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default LandingPage
